import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';

export default function StatusPopover() {
  const popover = (
    <Popover style={{ "maxWidth": "282px" }}>
      <Popover.Title as="h3">Status</Popover.Title>
      <Popover.Content>
        <p><b>Scheduled:</b> The form is scheduled and the patient will not be able to complete until the specified time.  </p>
        <p><b>Sent:</b> The form has been sent for completion.</p>
        <p><b>Completed:</b> The patient has completed the form.</p>
        <p><b>Canceled:</b> The form has been canceled and the patient can no longer complete.</p>
        <p><b>Expired:</b> The patient received the form, but did not complete.</p>
      </Popover.Content>
    </Popover>
  )

  return (
    <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
      <div className="statusQuestion">
        <span>Status</span>
        <i className="fa fa-question-circle ml-1" style={{ fontSize: "1.5em" }}></i>
      </div>
    </OverlayTrigger>
  )
}
